import { Component, ElementRef, Self } from '@angular/core';

@Component({
  selector: 'cai-panel',
  templateUrl: './panel.component.html',
  styleUrls: ['./panel.component.scss'],
  standalone: false,
})
export class CaiPanel {
  constructor(@Self() private el: ElementRef) {}
}
